import React, { useEffect, useState,useReducer } from 'react'
import {
    NavLink
} from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import sidebarReducer, { initialState } from '../../../features/sidebar/sidebarReducer'
import * as actionTypes from '../../utils/constants/ActionTypes'

import defaultLogo from '../../../assets/images/logo-blank.png'
import { parseTheme, MILITARY_DICTIONARY, revenueRadialGraph, formatPercent, vetfranCheckListValue, isSiteAssociatedToSalesToken } from '../../utils/common';
import setting from '../../utils/Settings'
import history from '../../../history'
import ifaWhite from '../../../assets/images/ifa-logo.png'
import engineIconCRM from '../../../assets/images/engine-orange-25x.png'

import useWindowDimensions from '../../hooks/UseWindowDimensions'
import StartupButton from '../Onboarding/StartupButton'
import SidePanelToggle from './Common/SidePanelToggle'
import StartupChecklist from '../Onboarding/StartupCheckList'
import ApexChart from '../ApexCharts/ApexChart'
import { getSalesTokenByOrg, revertToAdminSession } from '../../../features/session/sessionSlice'

const INITIAL_STATE = {
    prevPage: null,
    locDictionary: {
        performance: [ "site-performance", "pagespeed" ],
        campaign: [ "channel-performance", "ads-paid" ],
        report: [ "report-monthly", "report-annual", "crm-connect", "unit-sales", "score-card" ],
        summaries: [ "summaries-group", "summaries-company", "summaries-brand", "summaries-org" ]
    },
    showSidebar: true,
    showHeader: true,
    startupListPanel: false,
    sidebarMinified: false,
    activeClass: "",
    radialGraph: {
        ...revenueRadialGraph,
        options: {
            ...revenueRadialGraph.options,
            chart: {
                height: 100,
                width: 125,
                type: 'radialBar'
            },
            labels: ["Page Optimization Score"]
        }
    }
}

function Sidebar(){
    const reduxDispatch = useDispatch()

    const [state, setState] = useState(INITIAL_STATE)
    const { screenSize } = useWindowDimensions();

    const [stateReducer, dispatch] = useReducer(sidebarReducer, initialState);

    const model = useSelector(state => state.site.model)
    const user = useSelector(state => state.session.user)
    const isAdmin = useSelector(state => state.session.isAdmin)
    const adminSession = useSelector(state => state.session.adminSession)
    const trialMode = useSelector(state => state.session.trialMode)
    const useDarkMode = useSelector(state => state.session.useDarkMode)

    let sidebarStyle = {
        'backgroundColor':'#284699',
        'paddingTop': '68px'
    }
    let aTagStyle = {}
    let useBlackText = false

    const theme = parseTheme()
    if(theme){
        if(theme.sideMenuColorHex){
            sidebarStyle = {
                'backgroundColor':theme.sideMenuColorHex,
                'paddingTop': '68px'
            }
        }
    }

    if(useDarkMode){
        sidebarStyle = {
            ...sidebarStyle,
            'backgroundColor': "#2d353c"
        }

    }
    
    sidebarStyle = {
        ...sidebarStyle,
        zIndex: 2000
    }


    const checkLocation = (sidebarMinified = false) => {
        let { locDictionary } = state
        let dropdowns = {
            ...stateReducer.dropdowns
        }
        let activeClass = ""
        const href = history.location.pathname

        const splitHref = href.split("/")

        Object.keys(locDictionary).forEach(k => {
            if(!sidebarMinified && stateReducer.currentPage !== splitHref[splitHref.length - 1] && locDictionary[k].includes(splitHref[splitHref.length - 1])){
                dropdowns[k+"Expand"] = true
                activeClass = k+"Expand"
            } else if(sidebarMinified){
                dropdowns[k+"Expand"] = false
            }
        })

        return {
            currentPage: Array.isArray(splitHref) ? splitHref[splitHref.length - 1] ?? "overview" : "overview",
            dropdowns,
            activeClass
        }
    }

    const changeDropdown = (properties) => dispatch({
        type: actionTypes.DROPDOWN_CHANGE,
        properties
    })


    const visualComponent = (chartOptions) => <ApexChart type='radialBar'
        {...chartOptions}
        overrideTheme="dark"
        height={100}
        width={150} />
    

    useEffect(() => {
        const { militaryDictionary } = state
        const { currentPage, dropdowns, activeClass } = checkLocation()
            
        changeDropdown({
            currentPage,
            dropdowns,
        })
        
        setState(prevState => ({
            ...prevState,
            activeClass
        }))
        
    }, [])

    useEffect(() => {

        let hist = history.location.pathname.replace("/", "")
        
        if(hist.includes("/")){
            hist = hist.split("/")[0]
        }
        
        const idx = Object.keys(state.locDictionary)
            .find(k => state.locDictionary[k].includes(hist))
        
        if(idx){
            onSubMenuClick(`${idx}Expand`)
        } else {
            onSubMenuClick("")
        }

        window.scrollTo(0,0)

        if(trialMode){
            setState(prev => ({
                ...prev,
                startupListPanel: false
            }))
        }

    }, [history.location.pathname])

    useEffect(() => {
        
        if(model.logo !== state.logo){
            let newState = {
                logo: model.logo
            }

            if(model.militaryBranch !== undefined && model.militaryBranch !== state.militaryBranch){
                newState.militaryBranch = model.militaryBranch
            }
            setState(prevState => ({
                ...prevState,
                ...newState
            }))
        }

        if(model?.sites?.length > 0 && model?.siteActiveIdx !== -1){
            let { radialGraph } = state
            const site = model?.sites[model?.siteActiveIdx]
            
            if(site?.attr?.vetfranStats){
                let numerator = Object.keys(site?.attr?.vetfranStats).reduce((prev, key) => {
                    prev += site?.attr?.vetfranStats[key].completed ? vetfranCheckListValue[key] : 0
                    return prev
                }, 0)
                radialGraph.series = [numerator > 0 ? formatPercent(numerator, 100, true) : 0]
                setState(prev => ({
                    ...prev,
                    radialGraph
                }))
            } else if(site?.attr?.ifaStats){
                let numerator = Object.keys(site?.attr?.ifaStats).reduce((prev, key) => {
                    prev += site?.attr?.ifaStats[key].completed ? vetfranCheckListValue[key] : 0
                    return prev
                }, 0)
                radialGraph.series = [numerator > 0 ? formatPercent(numerator, 100, true) : 0]
                setState(prev => ({
                    ...prev,
                    radialGraph
                }))
            }
        }
    },[model])

    useEffect(() => {
        if(!isAdmin && model.orgActiveIdx != -1 && model?.organizations?.length > 0){
            const brand = model.orgActiveIdx >= 0 ? model.organizations[model.orgActiveIdx] : null

            if(isSiteAssociatedToSalesToken(brand.sitePath)){
                dispatch(getSalesTokenByOrg(brand.siteId))
            }

        }
    }, [model.orgActiveIdx])


    const onSubMenuClick = (key) => {
        let { locDictionary } = state
        let { dropdowns, currentPage } = checkLocation()
        Object.keys(dropdowns).forEach(k => {
            if(k !== key){
                dropdowns[k] = false
            } else {
                if(stateReducer.currentPage === currentPage){
                    dropdowns[k] = !dropdowns[k]

                } else {
                    dropdowns[k] = true
                }
            }
        })

        let foundKey = Object.keys(locDictionary).find(k => locDictionary[k].includes(currentPage))

        dropdowns[key] = foundKey ? true : dropdowns[key] ? false : true

        makeActive(foundKey ? key : dropdowns[key] ? "" : key)

        changeDropdown({
            currentPage,
            dropdowns,
        })

      
    }

    const checkSubMenuClass = (key) => {
        const { activeClass } = state
        const { dropdowns } = stateReducer
        let classes = ["has-sub"]

        if(activeClass === key){
            classes.push("active")
        }

        if(dropdowns && dropdowns[key]){
            classes.push("expand")
        } else {
            classes.push("closed")
        }

        return classes.join(" ")
    }

    const makeActive = (activeListItem) => {
        setState(prevState => ({
            ...prevState,
            activeClass: activeListItem
        }))
    }

    const toggleSidebarMinify = () => {
        const { sidebarMinified } = state
        const { dropdowns, currentPage } = checkLocation(!sidebarMinified)

        changeDropdown({
            currentPage,
            dropdowns
        })

        setState(prevState => ({
            ...prevState,
            sidebarMinified: !sidebarMinified
        }))
    }

    const { militaryDictionary, activeClass, startupListPanel, radialGraph } = state
    const { logo, militaryBranch, singleSiteUser } = model
    const { currentPage } = stateReducer

    const brand = model.orgActiveIdx >= 0 ? model.organizations[model.orgActiveIdx] : null
    const site = model.siteActiveIdx >= 0 ? model.sites[model.siteActiveIdx] : null

    const salesTokenSite = model?.salesTokens?.find(token => brand !== null ? brand.sitePath.startsWith(token.sitePath) : false)

    let crmUrl = null
    let crmImg = null

    if(site && site?.attr?.crmUrl){
        crmUrl = site?.attr?.crmUrl
    } else if(brand && brand?.attr?.crmUrl){
        crmUrl = brand?.attr?.crmUrl
    }
    
    if(site && site?.attr?.crmImg){
        crmImg = site?.attr?.crmImg
    } else if(brand && brand?.attr?.crmImg){
        crmImg = brand?.attr?.crmImg
    }
        
    return <React.Fragment>
        <SidePanelToggle showIconOnActive autoCloseOnBlur overrideActiveState={startupListPanel} onClick={() =>setState(prev => ({...prev, startupListPanel: false}))} align="left">
            {trialMode && <StartupChecklist />}
        </SidePanelToggle>
        <div id="sidebar" className={setting.layout.pageSidebarTransparent ? 'sidebar-transparent sidebar sidebar-grid toggler' :'sidebar sidebar-grid toggler' } style={sidebarStyle}>
            <div data-scrollbar="true" data-height="100%" data-init="true" style={{height: "100%", overflowY: "auto"}}>
                {adminSession !== null && <div className="text-center text-white">
                    <h4>Logged In as:</h4>
                    <h5>{ user?.given_name } { user?.family_name }</h5>
                    <button className="btn btn-danger mb-3" onClick={() => reduxDispatch(revertToAdminSession())}>
                        <i class="fas fa-user-secret"></i> Remove Disguise
                    </button>
                </div>}
                <img id="client-logo" src={model?.logo ? model.logo : defaultLogo} className="mx-auto d-block img-fluid" /><br />
                {(trialMode) && <StartupButton onClick={() => setState(prev => ({
                    ...prev,
                    startupListPanel: true
                }))}></StartupButton>}
                <ul className="nav" id="navSidebarSection">
                    <li className="nav-header">Navigation</li>
                    <li ui-sref-active="active" onClick={() => onSubMenuClick("")}>
                        <NavLink data-click={["sm", "xs"].includes(screenSize) ? "sidebar-toggled" : ""} activeClassName="text-white font-weight-bold" to="/overview">
                            <i className={ `${(useBlackText ? 'text-black': 'text-white')} fas fa-tachometer-alt pull-left m-r-10` }></i>
                            <span>Overview</span>
                        </NavLink>
                    </li>
                    <li id="auditTab" ui-sref-active="active" onClick={() => onSubMenuClick("")}>
                        <NavLink data-click={["sm", "xs"].includes(screenSize) ? "sidebar-toggled" : ""} activeClassName="text-white font-weight-bold" to="/audits">
                            <i className={ `${(useBlackText ? 'text-black': 'text-white')} ion ion-ios-podium fa-fw mr-sm-2` }></i>
                            <span>Audits &amp; Insights</span>
                        </NavLink>
                    </li>
                    {isAdmin && <li id="recommendationTab" ui-sref-active="active" onClick={() => onSubMenuClick("")}>
                        <NavLink data-click={["sm", "xs"].includes(screenSize) ? "sidebar-toggled" : ""} activeClassName="text-white font-weight-bold" to="/insights">
                            <i className={ `${(useBlackText ? 'text-black': 'text-white')} fas fa-id-card-alt fa-fw mr-sm-2` }></i>
                            <span>Recommendations</span>
                        </NavLink>
                    </li>}
                    {((isAdmin || (theme?.attr && theme?.attr.hasEcommerce)) && (!singleSiteUser || !site?.attr?.isFranchise)) && <li ui-sref-active="active" onClick={() => onSubMenuClick("")}>
                        <NavLink data-click={["sm", "xs"].includes(screenSize) ? "sidebar-toggled" : ""} activeClassName="text-white font-weight-bold" to="/ads-ecommerce">
                            <i className={ `${(useBlackText ? 'text-black': 'text-white')} ion ion-logo-usd fa-fw pull-left m-r-10` }></i>
                            <span>E-commerce</span>
                        </NavLink>
                    </li>}
                    <li className={checkSubMenuClass("performanceExpand")} onClick={() => onSubMenuClick("performanceExpand")}>
                        <a href="javascript:;" className={activeClass === "performanceExpand" ? "active" : ""}>
                            <b className="caret"></b>
                            <i className={ `${(useBlackText ? 'text-black': 'text-white')} ion ion-md-trending-up fa-2x fa-fw pull-left` }></i>
                        <span>Website Performance</span>
                        </a>
                        <ul id="performanceExpand" className={"sub-menu"}>
                            <li ui-sref-active="active">
                                <NavLink data-click={["sm", "xs"].includes(screenSize) ? "sidebar-toggled" : ""} activeClassName="text-white font-weight-bold" to="/site-performance">
                                    <i className={ `${(useBlackText ? 'text-black': 'text-white')} ion ion-md-trending-up fa-fw mr-sm-2` }></i>
                                    <span>Site Performance</span>
                                </NavLink>
                            </li>
                            <li ui-sref-active="active">
                                <NavLink data-click={["sm", "xs"].includes(screenSize) ? "sidebar-toggled" : ""} activeClassName="text-white font-weight-bold" to="/pagespeed">
                                    <i className={ `${(useBlackText ? 'text-black': 'text-white')} ion ion-ios-podium fa-fw mr-sm-2` }></i>
                                    <span>PageSpeed Insights</span>
                                </NavLink>
                            </li>
                        </ul>
                    </li>
                    <li className={checkSubMenuClass("campaignExpand")} onClick={() => onSubMenuClick("campaignExpand")}>
                        <a href="javascript:;" className={activeClass === "campaignExpand" ? "active" : ""}>
                        <b className="caret"></b>
                        <i className={ `${(useBlackText ? 'text-black': 'text-white')} fas fa-comments-dollar fa-2x fa-fw pull-left m-r-10` }></i>
                        <span>Channel Performance</span>
                        </a>
                        <ul id="campaignExpand" className={"sub-menu"}>
                            <li ui-sref-active="active">
                                <NavLink data-click={["sm", "xs"].includes(screenSize) ? "sidebar-toggled" : ""} activeClassName="text-white font-weight-bold" to="/channel-performance">
                                    <i className={ `${(useBlackText ? 'text-black': 'text-white')} fas fa-tv fa-fw pull-left mr-sm-2` }></i>
                                    <span>Channel Summary</span>
                                </NavLink>
                            </li> 
                            <li ui-sref-active="active">
                                <NavLink data-click={["sm", "xs"].includes(screenSize) ? "sidebar-toggled" : ""} activeClassName="text-white font-weight-bold" to="/ads-paid">
                                    <i className={ `${(useBlackText ? 'text-black': 'text-white')} fas fa-bullhorn fa-fw pull-left mr-sm-2` }></i>
                                    <span>Paid Campaigns</span>
                                </NavLink>
                            </li>
                        </ul>
                    </li>

                    <li ui-sref-active="active" onClick={() => onSubMenuClick("")}>
                        <NavLink data-click={["sm", "xs"].includes(screenSize) ? "sidebar-toggled" : ""} to="/google-business-profile" activeClassName="text-white font-weight-bold">
                            <i className={ `${(useBlackText ? 'text-black': 'text-white')} fas fa-briefcase pull-left m-r-10` }></i>
                            <span>Google Business Profile</span>
                        </NavLink>
                    </li>

                    <li ui-sref-active="active" onClick={() => onSubMenuClick("")}>
                        <NavLink data-click={["sm", "xs"].includes(screenSize) ? "sidebar-toggled" : ""} activeClassName="text-white font-weight-bold" to="/goals">
                            <i className={ `${(useBlackText ? 'text-black': 'text-white')} ion ion-md-pulse fa-2x fa-fw pull-left m-r-10` }></i>
                            <span>Goals &amp; Events</span>
                        </NavLink>
                    </li>
                    <li className={checkSubMenuClass("reportExpand")} onClick={() => onSubMenuClick("reportExpand")}>
                        <a href="javascript:;" className={activeClass === "reportExpand" ? "active" : ""}>
                            <b className="caret"></b>
                            <i className={ `${(useBlackText ? 'text-black': 'text-white')} ion ion-md-analytics fa-2x fa-fw pull-left m-r-10` }></i>
                            <span>Reports</span>
                        </a>
                        <ul id="reportExpand" className={"sub-menu"}>
                            <li ui-sref-active="active">
                                <NavLink data-click={["sm", "xs"].includes(screenSize) ? "sidebar-toggled" : ""} activeClassName="text-white font-weight-bold" to="/report-monthly">
                                    <i className={ `${(useBlackText ? 'text-black': 'text-white')} ion ion-ios-podium fa-fw mr-sm-2` }></i>
                                    <span>Monthly Report</span>

                                </NavLink>
                            </li>
                            <li ui-sref-active="active">
                                <NavLink data-click={["sm", "xs"].includes(screenSize) ? "sidebar-toggled" : ""} activeClassName="text-white font-weight-bold" to="/report-annual">
                                    <i className={ `${(useBlackText ? 'text-black': 'text-white')} ion ion-ios-podium fa-fw mr-sm-2` }></i>
                                    <span>Annual Report</span>

                                </NavLink>
                            </li>
                            <li ui-sref-active="active">
                                <NavLink data-click={["sm", "xs"].includes(screenSize) ? "sidebar-toggled" : ""} activeClassName="text-white font-weight-bold" to="/crm-connect">
                                    <i className={ `${(useBlackText ? 'text-black': 'text-white')} ion ion-ios-funnel fa-fw mr-sm-2` }></i>
                                    <span>CRM Connect</span>
                                </NavLink>
                            </li>
                            <li ui-sref-active="active">
                                <NavLink data-click={["sm", "xs"].includes(screenSize) ? "sidebar-toggled" : ""} activeClassName="text-white font-weight-bold" to="/unit-sales">
                                    <i className={ `${(useBlackText ? 'text-black': 'text-white')} ion ion-ios-podium fa-fw mr-sm-2` }></i>
                                    <span>Unit Sales Report</span>
                                </NavLink>
                            </li>
                            <li ui-sref-active="active">
                                <NavLink data-click={["sm", "xs"].includes(screenSize) ? "sidebar-toggled" : ""} activeClassName="text-white font-weight-bold" to="/score-card">
                                    <i className={ `${(useBlackText ? 'text-black': 'text-white')} fas fa-id-card-alt fa-fw mr-sm-2` }></i>
                                    <span>Score Card</span>
                                </NavLink>
                            </li>
                        </ul>
                    </li>
                    {(model.userSite?.type === "ORG" ||
                        !model.siteFixed || 
                        !model.regFixed) && <li className={checkSubMenuClass("summariesExpand")} onClick={() => onSubMenuClick("summariesExpand")}>
                        <a href="javascript:;" className={activeClass === "summariesExpand" ? "active" : ""}>
                            <b className="caret"></b>
                            <i className={ `${(useBlackText ? 'text-black': 'text-white')} ion ion-md-umbrella fa-2x fa-fw pull-left m-r-10` }></i>
                            <span>Summaries</span>
                        </a>
                        <ul id="summariesExpand" className={"sub-menu"}>
                            {(isAdmin || model.userSite?.type !== "TOP_ORG") && <li>
                                <NavLink data-click={["sm", "xs"].includes(screenSize) ? "sidebar-toggled" : ""} activeClassName="text-white font-weight-bold" to={"/summaries-" + setting.topLevelName.toLowerCase()}>
                                    <i className={ `${(useBlackText ? 'text-black': 'text-white')} ion ion-md-git-network fa-fw mr-sm-2` }></i>
                                    <span>{model.userSite?.linkedSites ? 'Multi Unit' :  setting.topLevelName}</span>
                                </NavLink>
                            </li>}
                            {(model.userSite?.type === "TOP_ORG") && <li>
                                <NavLink data-click={["sm", "xs"].includes(screenSize) ? "sidebar-toggled" : ""} activeClassName="text-white font-weight-bold" to={"/summaries-" + setting.topLevelName.toLowerCase()}>
                                    <i className={ `${(useBlackText ? 'text-black': 'text-white')} ion ion-md-git-network fa-fw mr-sm-2` }></i>
                                    <span>{model.userSite?.linkedSites ? 'Multi Unit' : 'Organization' }</span>
                                </NavLink>
                            </li>}
                        </ul>
                    </li>}

                    {crmUrl && <li ui-sref-active="active" id="crmLoginLink">
                        <a target="_blank" data-click={["sm", "xs"].includes(screenSize) ? "sidebar-toggled" : ""} activeClassName="text-white font-weight-bold" href={crmUrl}>
                            <img className="mr-sm-2" src={crmImg ? crmImg : engineIconCRM} style={{
                                width: "25px", height: "25px", 
                                border: "1px solid black", 
                                borderRadius: "5px",
                                backgroundColor: "black"
                            }} />
                            <span style={{
                                color: "black",
                                fontWeight: "bold"
                            }}>Partner Login</span>&nbsp;<span class="badge badge-warning" style={{
                                padding: "3px 5px",
                                border: "1px solid black", 
                                color: "black"
                            }}>NEW</span>
                        </a>
                    </li>}

                    <li>
                        <a href="javascript:;" className="sidebar-minify-btn" data-click="sidebar-minify" onClick={() => toggleSidebarMinify()}>
                            <i className={ `${(useBlackText ? 'text-black': 'text-white')} fa fa-angle-double-left` }></i>
                        </a>
                    </li>
                </ul>
                {site?.attr?.ifaStats && radialGraph.series[0] > 0 ? <>
                    <img src={ifaWhite} className="d-block mx-auto text-center" style={{width: "100px"}} />
                    <div className="d-flex justify-content-center">{visualComponent(radialGraph)}</div>
                </>: <></>}
                {salesTokenSite !== null && salesTokenSite?.attr?.logo ? <div className="mt-3">
                    <h5 className="text-white d-block mx-auto text-center">Sponsored By</h5>
                    <img src={salesTokenSite.attr.logo} className="mx-auto d-block img-fluid" />
                </div> : militaryBranch ? <div className="mt-3">
                    <h5 className="text-white d-block mx-auto text-center">Service Branch</h5>
                    <img src={MILITARY_DICTIONARY[militaryBranch]} className="mx-auto d-block img-fluid" />
                </div> : ""}

            {/* {theme && theme.placeholder && <a href={theme.placeholder.link} target="_blank">
            <img className="mx-auto img-fluid d-block" src={theme.placeholder.image} style={{paddingTop: "10px"}} />
            </a>}*/}

            </div>
        </div>
    </React.Fragment>


}

export default Sidebar